import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootPrintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_sales_order_queryService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { lookupCode?: string, owner?: string, project: string, ownerReference?: string, vendorReference?: string, warehouse?: string, status?: string, modifiedFrom?: string, modifiedTo?: string, trackQueriedOrders?: boolean, paging?: { top?: number, skip?: number }, shippedFrom?: string, shippedTo?: string }): Promise<{ payload?: any[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.project)) {
      missingRequiredInParams.push('\'project\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

